// extracted by mini-css-extract-plugin
module.exports = {"content":"page_content__GPOEA","videoEmbed":"page_videoEmbed__9IZFc","videoIframe":"page_videoIframe__quFtm","gallery":"page_gallery__lxl2h"};